module.exports = __webpack_public_path__ + "img/select_events.65cd6df8.svg";